import React, { useMemo } from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';

const TechnicianMarkers = ({ technicians = [] }) => {
  // Create a custom truck/hardhat icon using FontAwesome and Leaflet DivIcon
  const createTechIcon = (status) => {
    const color = status === 'busy' ? '#DD6B20' : '#38A169'; // Orange if busy, Green if active
    const pulse = status === 'active' ? 'pulse' : '';
    
    return L.divIcon({
      className: 'custom-tech-icon',
      html: `
        <div style="
          background-color: ${color}; 
          width: 30px; 
          height: 30px; 
          border-radius: 50%; 
          display: flex; 
          align-items: center; 
          justify-content: center;
          color: white;
          box-shadow: 0 0 10px ${color};
          border: 2px solid white;
        " class="${pulse}">
          <i class="fas fa-truck"></i>
        </div>
      `,
      iconSize: [30, 30],
      iconAnchor: [15, 15],
      popupAnchor: [0, -15]
    });
  };

  // Filter out technicians that don't have valid GPS coordinates
  const validTechs = useMemo(() => {
    return technicians.filter(t => 
      t.current_lat && 
      t.current_lng && 
      !isNaN(parseFloat(t.current_lat)) && 
      !isNaN(parseFloat(t.current_lng))
    );
  }, [technicians]);

  if (validTechs.length === 0) return null;

  return (
    <>
      {validTechs.map(tech => (
        <Marker
          key={`tech-${tech.id}`}
          position={[parseFloat(tech.current_lat), parseFloat(tech.current_lng)]}
          icon={createTechIcon(tech.status)}
          zIndexOffset={1000} // Ensure trucks render on top of pipelines
        >
          <Tooltip direction="top" offset={[0, -10]} opacity={0.9}>
            <div style={{ textAlign: 'center' }}>
              <strong>{tech.first_name} {tech.last_name}</strong><br/>
              <span style={{ fontSize: '10px', color: 'gray' }}>{tech.team_name || 'Unassigned'}</span><br/>
              <span style={{ 
                color: tech.status === 'busy' ? '#DD6B20' : '#38A169', 
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontSize: '10px'
              }}>
                {tech.status}
              </span>
            </div>
          </Tooltip>
        </Marker>
      ))}
    </>
  );
};

export default TechnicianMarkers;